import {httpClient} from "./httpClient";

export type BuildWarningRisk = "red" | "yellow" | "blue";

export type BuildWarning = {
    risk: BuildWarningRisk;
    title: string;
    message: string;
};

export type GetBuildWarningsResponse = {
    warnings: BuildWarning[];
};

export async function getBuildWarnings(): Promise<GetBuildWarningsResponse> {
    const {data} = await httpClient.get<GetBuildWarningsResponse>("/builds/warnings");
    return data;
}

export type BuildType = "zig";

export type GetBuildPayload = {
    type: BuildType;
};

export type GetBuildErrorResponse = {
    success: false;
    error?: string;
};

export type GetBuildZipSuccess = {
    success: true;
    blob: Blob;
    zipPassword: string | null;
};

export async function getBuild(
    payload: GetBuildPayload
): Promise<GetBuildZipSuccess | GetBuildErrorResponse> {
    const res = await httpClient.post<Blob>("/builds/get", payload, {
        responseType: "blob",
        timeout: 300_000,
    });

    const contentType = (res.headers?.["content-type"] as string | undefined) ?? "";

    // Если сервер вернул JSON (ошибка) — распарсим его из blob
    if (contentType.includes("application/json")) {
        try {
            const text = await res.data.text();
            const json = JSON.parse(text) as GetBuildErrorResponse | { success: true };
            if (json && (json as GetBuildErrorResponse).success === false) {
                return {
                    success: false,
                    error: (json as GetBuildErrorResponse).error,
                };
            }
        } catch {
            // fallthrough
        }
        return {success: false};
    }

    const zipPassword = (res.headers?.["x-zip-password"] as string | undefined) ?? null;
    return {
        success: true,
        blob: res.data,
        zipPassword,
    };
}

